import parse from 'html-react-parser';
import { parseMarginPadding, parseResult, parseItemResult } from '../controlUtils';
import { darkenHex } from "../colorUtils";
import { efWordByWord } from '../effectUtils';

export function displayListUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const display = parse(content.Display);
    const title = content.Title
    const theme = content.Theme;
    const size = parse(content.Size);
    const data = content.Data;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 16; let textSz = 16; let zoom = 0;
    if(size == "small"){
        titleSz = 20,
        textSz = 16
    } else if(size == "medium"){
        titleSz = 24,
        textSz = 20
    } else if(size == "large"){
        titleSz = 34,
        textSz = 24
    }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    if(entryPoint == "editor"){
        zoom = 60;
    }

    const styles = {
        container: {
            background: bgColor,
            zoom: `${zoom}%`,
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
            borderRadius: 5
        },
        title:{
            color: txtColor,
            marginBottom: 20,
            fontSize: titleSz,
            fontWeight: 600
        },
        listItem: {
            color: txtColor,
            marginBottom: 20,
            fontSize: textSz
        },
        listItemTitle:{
            fontWeight: 600,
            fontSize: textSz + 1
        },
        listItemIcon: {
            color: (bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 50),
            fontSize: textSz + 3, 
        },
        olNumStyles:
        `ol {
            list-style-type: decimal;
            padding-left: 20px;
        }
        ol li::marker {
            font-weight: bold;
            font-size: ${textSz + 3}px;
            color: ${(bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 70)};
        }`


    }

    function displayItem(type, itm){
        if(type == "ul"){
            return (
                <>
                    {(itm.Description != "")? 
                        <div><span style={styles.listItemTitle}>{itm.Title}</span> - {itm.Description}</div>:  
                        itm.Title
                    }
                    </>
            )
        }

        if(type == "ol"){
            return(
                <>
                    <li style={styles.listItem}>
                    {(itm.Description != "")? 
                        <div><b>{itm.Title}</b> - {itm.Description}</div>:  itm.Title
                    }
                    </li>
                </>
            )
        }
    }

    const elem =  (
        <div style={styles.container}>

            {(title != "") &&
                <><h4 style = {styles.title} className = 'element-title'>{parse(title)}</h4>
                <hr /></>
            }

            {(display == "ul") &&
                <ul className="fa-ul">
                    {data.map((itm, i)=>(
                        <li style={styles.listItem}>
                        <span class="fa-li"><i style={styles.listItemIcon} className="fa fa-check-circle"></i></span>
                        {parseItemResult( displayItem("ul", itm), obj, entryPoint, ((i + 1) * 0.3) )}
                        </li>
                    ))}
                </ul>
            }

            {(display == "ol") &&
            <div>
                <style>{styles.olNumStyles}</style>
                <ol>
                    {data.map((itm, i)=>(
                        parseItemResult( displayItem("ol", itm), obj, entryPoint, ((i + 1) * 0.3) )
                    ))}
                </ol>
                </div>
            }
        </div>
    )

    return elem;
}